import { render, staticRenderFns } from "./moreProblemSolving.vue?vue&type=template&id=643f0eea&"
import script from "@viewJs/home/moreProblemSolving.js?vue&type=script&lang=js&"
export * from "@viewJs/home/moreProblemSolving.js?vue&type=script&lang=js&"
import style0 from "./moreProblemSolving.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports